import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  const transformations = ['Más confianza', 'Menos ansiedad', 'Erecciones más estables', 'Mayor control', 'Más tranquilidad mental', 'Mejor conexión con tu pareja'];
  return <section className="relative w-full bg-[#0a0a0a] py-10 md:py-16 overflow-hidden" data-id="element-526">
      <div className="absolute inset-0 z-0" data-id="element-527">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] rounded-full bg-red-800/10 blur-[130px]" data-id="element-528" />
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-529">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-530">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-531">
            <div className="w-12 h-px bg-red-600" data-id="element-532" />
            <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-533">
              Tu Nueva Realidad
            </span>
            <div className="w-12 h-px bg-red-600" data-id="element-534" />
          </div>

          <h2 className="font-display text-4xl md:text-6xl uppercase mb-10 text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-535">
            Lo que puede cambiar en tu vida
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-536">
            {transformations.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/40 rounded-xl p-6 flex flex-col items-center text-center shadow-[0_0_20px_rgba(220,38,38,0.05)] hover:border-red-600/50 transition-all duration-500" data-id="element-537">
                <div className="w-12 h-12 rounded-full bg-red-900/20 border border-red-500/30 flex items-center justify-center mb-4" data-id="element-538">
                  <span className="text-red-500 text-xl drop-shadow-[0_0_8px_rgba(220,38,38,0.6)]" data-id="element-539">
                    ✔
                  </span>
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-white" data-id="element-540">
                  {item}
                </h3>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}